import React from "react";
import DOMPurify from 'dompurify';

function WorkTile(props){

  return (
    <a href={ `/${props.slug}` } role='button' className="tile work">
      <h2 dangerouslySetInnerHTML={{ __html:DOMPurify.sanitize(props.title) }} />
      <div 
        className='excerpt' 
        dangerouslySetInnerHTML={{ __html:DOMPurify.sanitize(props.excerpt) }}
        />
    </a>
  );
}

export default WorkTile;